import Head from 'next/head';
import { Col, Container, Row } from 'reactstrap';

import Layout from '../../components/layout/layout';
import useI18n from '../../hooks/use-i18n';
import { languages, contentLanguageMap } from '../../language.config';
import getTranslationKeys, { PAGEID } from '../../utils/i18nRosseta';

import '../../styles/privacy.scss';

const ConsumerProtectionPolicy = () => {
  const i18n = useI18n();
  const pageMetaData = i18n.t('metadata').consumer_protection_policy_page;

  return (
    <Layout
      page="cpp"
      title={pageMetaData.title}
      description={pageMetaData.description}
      keywords={pageMetaData.keywords}
      pageUrl="consumer_protection_policy"
      pageEnabledMarkets={['vn']}
    >
      <Head />
      <section className="content-page-wrapper">
        <Container>
          <Row>
            <Col xl={{ size: 8, order: 2, offset: 2 }}>
              <h1>CHÍNH SÁCH BẢO VỆ THÔNG TIN CÁ NH N CỦA NGƯỜI TIÊU DÙNG</h1>
              <ol>
                <li>
                  <h5>Mục đích thu thập thông tin</h5>
                  <p>
                    Bằng việc trao cho chúng tôi thông tin cá nhân của bạn khi đăng kí sử dụng dịch vụ,
                    bạn đồng ý thông tin cá nhân của mình sẽ được thu thập, sử dụng như được nêu trong Chính sách này.
                    Nếu bạn không đồng ý với Chính sách này, bạn dừng cung cấp cho chúng tôi bất cứ thông
                    tin cá nhân nào và/hoặc sử dụng các quyền được nêu tại mục 7 dưới đây. Chúng tôi bảo
                    lưu quyền sửa đổi, bổ sung nhằm hoàn thiện đối với Chính Sách này vào bất kỳ thời điểm nào.
                    Chúng tôi khuyến khích bạn thường xuyên xem lại Chính Sách Bảo Mật Thông Tin Cá Nhân này
                    để có được những cập nhật mới nhất đảm bảo bạn biết và thực hiện quyền quản lý thông tin
                    cá nhân của bạn.
                  </p>

                </li>
                <li>
                  <h5> Phạm vi sử dụng thông tin cá nhân</h5>
                  <p>
                    Chúng tôi sử dụng dữ liệu cá nhân của bạn để cung cấp cho bạn các Dịch vụ liên quan
                    và để vận hành doanh nghiệp của chúng tôi. Chúng tôi cũng có thể sử dụng dữ liệu
                    được thu thập để liên lạc với bạn; chẳng hạn, để thông báo cho bạn về các tính
                    năng mới của Dịch vụ, cập nhật bảo mật hoặc để thông báo cho bạn về tài khoản của bạn.
                    Dữ liệu cá nhân của bạn cũng có thể được sử dụng để hiển thị cho bạn thông tin, nội dung,
                    quảng cáo phù hợp hơn, cho dù thông qua Dịch vụ hoặc ứng dụng của bên thứ ba và kết hợp
                    với thông tin từ các nguồn khác.
                    Một số ví dụ về cách chúng tôi thường sử dụng dữ liệu cá nhân của bạn bao gồm:
                  </p>
                  <ul>
                    <li> xử lý, ghi lại, theo dõi và thực hiện các giao dịch hoặc yêu cầu của bạn;</li>
                    <li> tạo điều kiện cho chúng tôi cung cấp Dịch vụ;</li>
                    <li>  liên lạc với bạn cho các mục đích nghiên cứu, tiếp thị, quảng cáo;</li>
                    <li>
                      vấn đề hành chính đối với giao dịch mua và / hoặc đăng ký của bạn đối với Dịch vụ;
                      quản lý tài khoản của bạn, xử lý đăng ký/ đăng nhập của bạn cho danh sách gửi thư, v.v.;
                    </li>
                    <li>  Chẩn đoán và duy trì Dịch vụ;</li>
                    <li>  Duy trì tính bảo mật của Dịch vụ;</li>
                    <li>  Để bảo vệ bạn và những người dùng khác của Dịch vụ và khách truy cập;</li>
                    <li>  Thực thi các chính sách và thủ tục của chúng tôi;</li>
                    <li>  Để bạn gửi câu hỏi, phản hồi hoặc khiếu nại; và / hoặc</li>
                    <li>  Các mục đích khác sẽ được thông báo cho bạn vào từng thời điểm</li>
                  </ul>

                </li>
                <li>
                  <h5>Thời gian lưu trữ thông tin cá nhân</h5>
                  <p>
                    Không có thời hạn trừ trường hợp bạn bạn muốn rút lại sự đồng ý đối với việc chúng
                    tôi sử dụng dữ liệu cá nhân của bạn, vui lòng ngừng sử dụng Dịch vụ ngay lập tức và
                    thông báo cho chúng tôi bằng văn bản theo địa chỉ privacy@zenyum.sg để thông báo cho
                    chúng tôi rằng bạn muốn chúng tôi ngừng thu thập, sử dụng hoặc chia sẻ cá nhân của bạn dữ
                    liệu và chúng tôi sẽ xử lý yêu cầu của bạn trong một thời gian hợp lý từ yêu cầu đó. Bạn
                    cũng có thể chọn rút lại sự đồng ý đối với việc sử dụng dữ liệu cá nhân của bạn cho một mục
                    đích cụ thể, vì vậy hãy đảm bảo rằng thông báo của bạn chứa thông tin đầy đủ và cụ thể để
                    cho phép chúng tôi tuân thủ yêu cầu của bạn.
                  </p>
                </li>
                <li>
                  <p>
                    {' '}
                    Những người hoặc tổ chức có thể được tiếp cận với thông tin cá nhân của
                    người tiêu dùng Trong một số trường hợp, chúng tôi cũng có thể cần chia sẻ dữ liệu
                    cá nhân của bạn với các bên thứ ba như các công ty con, chi nhánh, công ty liên quan,
                    nhà cung cấp dịch vụ, nhà cung cấp, như một phần mở rộng của dịch vụ chăm sóc bệnh nhân
                    của bạn như là một phần của Điều trị Zenyum hoặc theo quy định chính quyền hoặc các bên
                    thứ ba khác. Các bên thứ ba xử lý dữ liệu cá nhân của bạn thay mặt chúng tôi hoặc có thể được
                    đặt ở một quốc gia khác từ điểm thu thập dữ liệu cá nhân của bạn (ví dụ: chuyển đến các máy
                    chủ ở bên ngoài quốc gia bạn đang truy cập Dịch vụ) hoặc có thể có nhiều vị trí và sao lưu vật
                    lý (ví dụ: dịch vụ dựa trên điện toán đám mây) .
                  </p>
                  <p>
                    Trường hợp dữ liệu cá nhân của bạn phải được chia sẻ với bên thứ ba trong những trường
                    hợp không được dự tính hợp lý trong quá trình giao dịch thông thường của chúng tôi với bạn,
                    trước tiên chúng tôi thường tìm kiếm sự đồng ý của bạn trừ khi tiết lộ:
                  </p>
                  <ul>
                    <li> Được yêu cầu hoặc ủy quyền dựa trên luật pháp và / hoặc quy định hiện hành;</li>
                    <li> Rõ ràng là vì lợi ích của bạn, và nếu không thể có được sự đồng ý một cách kịp thời;</li>
                    <li>
                      Là cần thiết để ứng phó với tình huống khẩn cấp đe dọa đến tính mạng,
                      sức khỏe hoặc sự an toàn của chính bạn hoặc cá nhân khác;
                    </li>
                    <li>Là cần thiết cho bất kỳ điều tra hoặc tố tụng;</li>
                    <li>  Được yêu cầu bởi một cơ quan thực thi pháp luật;</li>
                    <li> Là cho một cơ quan công cộng và cần thiết vì lợi ích công cộng; và / hoặc</li>
                    <li>Khi việc tiết lộ như vậy mà không có sự đồng ý của bạn được pháp luật cho phép.</li>

                  </ul>

                  <p>
                    Trường hợp chúng tôi tiết lộ dữ liệu cá nhân của bạn cho các bên thứ ba, chúng
                    tôi sẽ sử dụng những nỗ lực tốt nhất của chúng tôi để yêu cầu các bên thứ ba đó
                    bảo vệ dữ liệu cá nhân của bạn.
                  </p>
                  <p>
                    Bằng cách sử dụng Dịch vụ của chúng tôi, bạn đồng ý rằng việc chuyển dữ liệu cá
                    nhân của bạn sang nhiều quốc gia khác nhau là cần thiết để chúng tôi cung cấp cho
                    bạn các Dịch vụ này

                  </p>
                </li>
                <li>
                  <h5>Địa chỉ của đơn vị thu thập và quản lý thông tin</h5>
                  <p> Công ty TNHH Zenyum Vietnam</p>
                  <p>Địa chỉ: 167- 169 Điện Biên Phủ, phường Đa Kao, quận 1</p>
                  <p>
                    Email:&nbsp;
                    <a href="mailto:smile.vietnam@zenyum.com">smile.vietnam@zenyum.com</a>
                  </p>
                </li>
                <li>
                  <h5>
                    Phương tiện và công cụ để người tiêu dùng tiếp cận và chỉnh sửa dữ liệu thông tin
                    cá nhân của mình
                  </h5>
                  <p>
                    Bạn có thể yêu cầu quyền truy cập hoặc chỉnh sửa dữ liệu cá nhân do chúng tôi nắm giữ bằng
                    cách gửi yêu cầu bằng văn bản bất cứ lúc nào tới
                    <a href="mailto: privacy@zenyum.sg"> Privacy@zenyum.sg</a>
                    Chúng tôi có thể yêu cầu thêm thông tin từ bạn để xác minh danh
                    tính cũng như bản chất của yêu cầu của bạn,
                    để giải quyết yêu cầu của bạn. Phí xử lý và xử lý có thể phải trả
                    trước khi chúng tôi có thể tiến hành yêu cầu của bạn.
                    Khi chúng tôi có đủ thông tin để giải quyết yêu cầu của bạn, chúng
                    tôi sẽ tìm cách cung cấp cho bạn dữ liệu
                    hoặc thông tin cá nhân có liên quan trong vòng ba mươi
                    (30) ngày kể từ khi bạn yêu cầu, trừ khi có quy định khác.

                  </p>

                </li>
                <li>
                  <h5>Cam kết bảo mật thông tin cá nhân của người tiêu dùng</h5>
                  <p>
                    Chúng tôi coi trọng quyền riêng tư của bạn và có các sắp xếp bảo mật để đảm bảo dữ
                    liệu cá nhân của bạn được bảo vệ và bảo mật đầy đủ. Chúng tôi cũng sẽ áp dụng các biện
                    pháp sao cho dữ liệu cá nhân của bạn thuộc quyền sở hữu hoặc dưới sự kiểm soát của chúng
                    tôi bị hủy và / hoặc ẩn danh ngay khi có lý khi cho rằng: (i) mục đích mà dữ liệu cá nhân
                    được thu thập không còn nữa được phục vụ bởi việc lưu giữ dữ liệu cá nhân đó; và (ii) giữ lại
                    không còn cần thiết cho bất kỳ mục đích kinh doanh hoặc pháp lý nào khác. Mặt khác, dữ liệu cá
                    nhân do chúng tôi thu thập thường chỉ được lưu giữ miễn là cần thiết một cách hợp lý cho mục
                    đích mà dữ liệu được cung cấp và chúng tôi có thể hủy hoặc xóa bất kỳ thông tin hoặc dữ liệu
                    cá nhân nào do bạn cung cấp sau đó, trừ khi luật pháp, quy định hoặc yêu cầu kinh doanh hoặc
                    kiểm toán khác.
                  </p>
                </li>
                <li>
                  <p>
                    Cơ chế tiếp nhận và giải quyết khiếu nại liên quan đến việc thông tin của người tiêu
                    dùng Khi phát hiện thông tin cá nhân của mình bị sử dụng sai mục đích hoặc phạm vi,
                    Người Tiêu Dùng gửi email khiếu nại đến email
                    <a href="mailto:smile.vietnam@zenyum.com">smile.vietnam@zenyum.com</a>
                    để khiếu nại
                    và cung cấp chứng cứ liên quan tới vụ việc cho Zenyum. Zenyum cam kết sẽ phản hồi ngay lập
                    tức hoặc muộn nhất là trong vòng 24 (hai mươi tư) giờ làm việc kể từ thời điểm nhận được khiếu nại.

                  </p>
                </li>
              </ol>
            </Col>
          </Row>
        </Container>
      </section>
    </Layout>
  );
};
export async function getStaticProps({ params }) {
  const lngDict = {};
  const pageId = PAGEID.CONSUMER_PROTECTION_POLICY;
  const keys = getTranslationKeys(pageId);
  const { default: lngDictAll = {} } = await import(
    `../../locales/${contentLanguageMap[params.lng]}.json`
  );
  keys.forEach((data) => {
    lngDict[data] = lngDictAll[data];
  });
  return {
    props: { lng: params.lng, lngDict, pageId }
  };
}

export async function getStaticPaths() {
  return {
    paths: languages.map((l) => ({ params: { lng: l } })),
    fallback: false
  };
}

export default ConsumerProtectionPolicy;
